import GeneralSettingsService from 'external-services/general-settings-service/generalSettings.service';
import {cloneDeep} from 'lodash-es';
import {floorplanSettingsActions} from 'floorplan-v2/app/reducers/settings/slice';
import store from 'appRoot/Store';

const NS = 'FloorPlanSettingsCtrl';

const forceBookingCreator = !!window.config?.forceBookingCreator;
const forceBookingCardList = !!window.config?.forceBookingCardList;

export default function FloorPlanSettingsCtrl(
  $log, $state, $rootScope, $mdToast, $scope
) {
  "ngInject";

  const vm = this;
  vm.save = save;
  vm.handleBookingSlotsAvailabilityChange = handleBookingSlotsAvailabilityChange;
  vm.reloadRequired = false;

  if (forceBookingCreator) {
    vm.showEnableBookingCreatorOnTimeline = false;
    vm.showEnableBookingCreatorOnFloorplan = false;
  } else {
    vm.showEnableBookingCreatorOnTimeline = false;
    vm.showEnableBookingCreatorOnFloorplan = true;
  }

  if (forceBookingCardList) {
    vm.showEnableBookingCardListOnTimeline = false;
  } else {
    vm.showEnableBookingCardListOnTimeline = true;
  }

  vm.onBookingCreatorChanged = () => {
    vm.reloadRequired = true;
  };

  init();
  function init() {
    GeneralSettingsService.get().then(settings => {
      const _settings = cloneDeep(settings);
      vm.settings = _settings;
      if (!vm.settings.floorPlanSettings) {
        vm.settings.floorPlanSettings = {};
        vm.settings.floorPlanSettings.overviewZoom = 0.5;
        vm.settings.floorPlanSettings.statusZoom = 0.75;
        vm.settings.floorPlanSettings.scheduleZoom = 1;
        vm.settings.floorPlanSettings.showSectionName = true;
        vm.settings.floorPlanSettings.minBookingSlotsAvailability = 60;
        vm.settings.floorPlanSettings.maxBookingSlotsAvailability = 120;

        /**
         * Replaces enableBookingCreator (html configs) and settings.showNewBookingDialog
         */
        vm.settings.floorPlanSettings.enableBookingCreatorOnFloorplan = true;
        vm.settings.floorPlanSettings.enableBookingCreatorOnTimeline = false;
      }
      store.dispatch(floorplanSettingsActions.setFloorplanSettings(cloneDeep(vm.settings.floorPlanSettings)));
    });
  }
  function handleBookingSlotsAvailabilityChange(numbers) {
    if (numbers && numbers.length === 2) {
      vm.settings.floorPlanSettings.minBookingSlotsAvailability = numbers[0];
      vm.settings.floorPlanSettings.maxBookingSlotsAvailability = numbers[1];
    }
  }
  function save() {
    GeneralSettingsService.save(vm.settings).then(settings => {
      store.dispatch(floorplanSettingsActions.setFloorplanSettings(cloneDeep(settings.floorPlanSettings)));

      $mdToast.show(
        $mdToast.simple()
          .content('Floor Plan Settings Saved')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );

      if (vm.reloadRequired) {
        window.location.reload();
      }
    });
  }
}
